module.exports = __webpack_public_path__ + "img/login-vector.310db59c.webp";